import { css } from "@emotion/css";
import { LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import { CheckCircleIcon, MinusCircleIcon, TimeCircleIcon } from "@octopusdeploy/design-system-icons";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import { DeploymentFreezeStatus } from "@octopusdeploy/octopus-server-client";
import Chip from "~/components/Chips/Chip";
interface DeploymentFreezeDataTableStatusCellProps {
    status: DeploymentFreezeStatus;
    colSpan?: number;
    totalItems?: number;
}
export const DeploymentFreezeDataTableStatusCell = ({ status, colSpan, totalItems }: DeploymentFreezeDataTableStatusCellProps) => {
    switch (status) {
        case DeploymentFreezeStatus.Scheduled:
            return (<LegacyDataTableRowColumn colSpan={colSpan} className={cellStyles}>
                    <div className={statusCellStyles}>
                        <TimeCircleIcon size={24} color={themeTokens.color.icon.info}/>
                        <div>Scheduled</div>
                        {totalItems && <Chip>{totalItems}</Chip>}
                    </div>
                </LegacyDataTableRowColumn>);
        case DeploymentFreezeStatus.Active:
            return (<LegacyDataTableRowColumn colSpan={colSpan} className={cellStyles}>
                    <div className={statusCellStyles}>
                        <CheckCircleIcon size={24} color={themeTokens.color.icon.success}/>
                        <div>Active</div>
                        {totalItems && <Chip>{totalItems}</Chip>}
                    </div>
                </LegacyDataTableRowColumn>);
        case DeploymentFreezeStatus.Unscoped:
            return (<LegacyDataTableRowColumn colSpan={colSpan} className={cellStyles}>
                    <div className={statusCellStyles}>
                        <MinusCircleIcon size={24} color={themeTokens.color.icon.secondary}/>
                        <div>Unscoped</div>
                        {totalItems && <Chip>{totalItems}</Chip>}
                    </div>
                </LegacyDataTableRowColumn>);
        case DeploymentFreezeStatus.Expired:
        default:
            return (<LegacyDataTableRowColumn colSpan={colSpan} className={cellStyles}>
                    <div className={statusCellStyles}>
                        <TimeCircleIcon size={24} color={themeTokens.color.icon.secondary}/>
                        <div>Expired</div>
                        {totalItems && <Chip>{totalItems}</Chip>}
                    </div>
                </LegacyDataTableRowColumn>);
    }
};
const statusCellStyles = css({
    display: "flex",
    alignItems: "center",
    gap: space[4],
});
const cellStyles = css({ width: "100%" });
